"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchConfig = getFetchConfig;
exports["default"] = void 0;

var _uuid = _interopRequireDefault(require("uuid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _process$env = process.env,
    NAME = _process$env.NAME,
    VERSION = _process$env.VERSION;

function getFetchConfig(config) {
  var body = config.body,
      method = config.method,
      token = config.token;
  var init = {
    credentials: 'include',
    method: method
  };
  init.headers = {
    AppName: NAME,
    AppVersion: VERSION,
    'X-Request-ID': (0, _uuid["default"])()
  };

  if (method !== 'GET') {
    var formatBody = body;
    var isFormDataBody = formatBody instanceof FormData;

    if (formatBody && !isFormDataBody) {
      var fileValue = Object.values(body).find(function (value) {
        return value instanceof File;
      });

      if (fileValue) {
        var formData = new FormData();
        Object.keys(formatBody).forEach(function (key) {
          return formData.append(key, formatBody[key]);
        });
        formatBody = formData;
        isFormDataBody = true;
      }
    }

    if (!isFormDataBody) {
      Object.assign(init.headers, {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      });
    }

    init.body = init.headers['Content-Type'] === 'application/json' ? JSON.stringify(body || {}) : body;
  }

  if (token) {
    if (!init.headers) {
      init.headers = {};
    }

    init.headers.Authorization = "Bearer ".concat(token);
  }

  return init;
}

var _default = getFetchConfig;
exports["default"] = _default;